'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withProgress;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProgressProvider = require('../components/ProgressProvider');

var _ProgressProvider2 = _interopRequireDefault(_ProgressProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function withProgress(ProgressBarComponent) {
  function ProgressBarProvider(props) {
    return _react2.default.createElement(
      _ProgressProvider2.default,
      { isLoading: props.isLoading },
      _react2.default.createElement(ProgressBarComponent, null)
    );
  }

  ProgressBarProvider.propTypes = {
    isLoading: _react.PropTypes.bool
  };

  return ProgressBarProvider;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/reprogressbars/lib/hoc/withProgress.js
// module id = 124
// module chunks = 0